module.exports = __webpack_public_path__ + "img/21.f2391846.png";